(function () {
  if (window.__DDP_LOADED__) return;
  window.__DDP_LOADED__ = true;

  const CUTOFF_HOUR = 19;            // L-V: último pedido para entrega el mismo día
  const SATURDAY_CUTOFF_HOUR = 12;   // sábados solo entregas por la mañana
  const MORNING_CUTOFF_HOUR = 12;    // antes de esta hora se entrega por la mañana
  const MAX_CAROUSEL_DAYS = 10;
  const MAX_HORIZON_DAYS = 60;
  const MIN_DELIVERY_DATE = '2026-10-13';   // no se entrega antes de esta fecha

  function pad(n) { return String(n).padStart(2, '0'); }
  function fmt(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }
  function fmtDisplay(dateStr) {
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
}
  function isWeekend(d) { const x = d.getDay(); return x === 0; }
  //function isWeekend(d) { return false; }
  function wd(d) { return ['D', 'L', 'M', 'X', 'J', 'V', 'S'][d.getDay()]; }
  function isSameDay(a, b) { return fmt(a) === fmt(b); }

function getStartDate() {
  const now = new Date();
  const start = new Date(now);
  const cutoff = now.getDay() === 6 ? SATURDAY_CUTOFF_HOUR : CUTOFF_HOUR;
  if (now.getHours() >= cutoff) start.setDate(start.getDate() + 1);

  // Suelo de fecha: nunca antes de MIN_DELIVERY_DATE
  if (MIN_DELIVERY_DATE && fmt(start) < MIN_DELIVERY_DATE) {
    return new Date(MIN_DELIVERY_DATE + 'T00:00:00');
  }
  return start;
}

  function genDates() {
    const out = [];
    let d = getStartDate();
    while (out.length < MAX_CAROUSEL_DAYS) {
      if (!isWeekend(d)) out.push(new Date(d));
      d.setDate(d.getDate() + 1);
    }
    return out;
  }

function updateCartAttribute(date) {
  const attrUpdate = fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { Fecha_Entrega: fmtDisplay(date) } })
  }).then(r => r.json());

  const lineUpdate = fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const promises = cart.items.map(item => {
        const updatedProperties = {
          ...(item.properties || {}),
          'Fecha de entrega': fmtDisplay(date)
        };
        
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            properties: updatedProperties
          })
        }).then(r => r.json());
      });
      return Promise.all(promises);
    });

  return Promise.all([attrUpdate, lineUpdate]);
}

  function init(root) {
    if (!root || root.dataset.ddpInit === '1') return;
    root.dataset.ddpInit = '1';

    const carousel = root.querySelector('[data-ddp-carousel]');
    const openBtn = root.querySelector('[data-ddp-open]');
    const note = root.querySelector('[data-ddp-note]');
    const error = root.querySelector('[data-ddp-error]');
    const modal = root.querySelector('[data-ddp-modal]');
    const dateInput = root.querySelector('[data-ddp-input]');
    const saveBtn = root.querySelector('[data-ddp-save]');
    const cancelBtn = root.querySelector('[data-ddp-cancel]');
    const prevBtn = root.querySelector('[data-ddp-prev]');
    const nextBtn = root.querySelector('[data-ddp-next]');
    const initialInput = root.querySelector('[data-ddp-initial]');

    if (!carousel || !openBtn || !modal || !dateInput || !saveBtn || !cancelBtn || !note || !error) return;

    let selectedDate = (initialInput && initialInput.value) ? initialInput.value : '';

    function select(dateStr) {
      selectedDate = dateStr;

      updateCartAttribute(dateStr)
        .then(() => error.classList.remove('show'))
        .catch(() => {});

      root.querySelectorAll('.ddp-card').forEach(btn => {
        const on = btn.dataset.date === dateStr;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function render() {
      const dates = genDates();
      const today = new Date();
      const tomorrow = new Date(today); tomorrow.setDate(tomorrow.getDate() + 1);

      carousel.innerHTML = '';
      dates.forEach(d => {
        const dateStr = fmt(d);
        const tag = isSameDay(d, today) ? 'Hoy' : (isSameDay(d, tomorrow) ? 'Mañana' : '');

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ddp-card';
        btn.dataset.date = dateStr;
        btn.setAttribute('aria-pressed', 'false');
        btn.innerHTML = `
          <div class="ddp-weekday">${wd(d)}</div>
          <div class="ddp-day">${d.getDate()}</div>
          <div class="ddp-tag">${tag}</div>
        `;
        btn.addEventListener('click', () => select(dateStr));
        carousel.appendChild(btn);
      });

const now = new Date();
const hoyStr = fmt(now);
const esSabado = now.getDay() === 6;
const esDomingo = now.getDay() === 0;

      if (MIN_DELIVERY_DATE && hoyStr < MIN_DELIVERY_DATE) {
      const [a, m, d] = MIN_DELIVERY_DATE.split('-');
      note.textContent = `Las entregas comienzan el ${d}/${m}. Puedes hacer tu pedido ya y lo entregamos a partir de esa fecha.`;
      } else if (esDomingo) {
        note.textContent = 'Los domingos no realizamos entregas. (L-S)';
      } else if (esSabado) {
        note.textContent = `Los sábados solo entregamos por la mañana: pide antes de las ${SATURDAY_CUTOFF_HOUR}:00. (L-S)`;
      } else if (now.getHours() < MORNING_CUTOFF_HOUR) {
        note.textContent = `Pide antes de las ${MORNING_CUTOFF_HOUR}:00 y recibes hoy por la mañana. Después, entrega por la tarde. (L-S)`;
      } else {
        note.textContent = `Pedidos hasta las ${CUTOFF_HOUR}:00 se entregan hoy por la tarde. (L-S)`;
      }

      if (selectedDate) select(selectedDate);

      if (prevBtn && nextBtn) setTimeout(updateArrows, 0);
    }

    openBtn.addEventListener('click', () => {
      const today = new Date();
      const min = getStartDate();
      const max = new Date(today); max.setDate(max.getDate() + MAX_HORIZON_DAYS);

      dateInput.min = fmt(min);
      dateInput.max = fmt(max);
      dateInput.value = selectedDate || fmt(min);

      modal.showModal();
    });

    saveBtn.addEventListener('click', () => {
      const v = dateInput.value;
      if (!v) return;

      const d = new Date(v + 'T00:00:00');
      if (isWeekend(d)) { alert('No realizamos entregas los domingos.'); return; }

      select(v);
      modal.close();
    });

    cancelBtn.addEventListener('click', () => modal.close());
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });

    function bindCheckoutBlock() {
      const btns = document.querySelectorAll('[name="checkout"], .cart__checkout-button, [href*="/checkout"]');
      btns.forEach(b => {
        if (b.dataset.ddpBound === '1') return;
        b.dataset.ddpBound = '1';
        b.addEventListener('click', (e) => {
          if (!selectedDate) {
            e.preventDefault();
            e.stopPropagation();
            error.classList.add('show');
            root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            return false;
          }
        }, true);
      });
    }

    function scrollByCards(dir) {
      const first = carousel.querySelector('.ddp-card');
      if (!first) return;
      const cardWidth = first.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(carousel).gap || '0');
      const step = (cardWidth + gap) * 4;
      carousel.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    function updateArrows() {
      const max = carousel.scrollWidth - carousel.clientWidth;
      const x = carousel.scrollLeft;
      const tol = 2;
      prevBtn.disabled = x <= tol;
      nextBtn.disabled = x >= (max - tol);
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => scrollByCards(-1));
      nextBtn.addEventListener('click', () => scrollByCards(1));
      carousel.addEventListener('scroll', () => requestAnimationFrame(updateArrows));
      window.addEventListener('resize', () => updateArrows());
    }

    render();
    setTimeout(bindCheckoutBlock, 400);
  }

  function initAll() {
    document.querySelectorAll('[data-ddp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // This is what fixes the "first open drawer doesn't show"
  const obs = new MutationObserver(() => initAll());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
